import { Breadcrumbs, Breadcrumb } from '@vp/swan'
import { Article } from '../../types/article.type'
import { useTranslation } from 'react-i18next'
import { HelpCenterUrls } from '../../types/helpCenterUrls.type'

interface BreadcrumbsProps {
  article: Article
  locale: string
  tenant: string
  helpCenterUrls: HelpCenterUrls | null
}

export const BreadcrumbsComponent = ({ article, locale, tenant, helpCenterUrls }: BreadcrumbsProps) => {
  const { t } = useTranslation(tenant)
  const lng = locale.toLowerCase().replace('-', '_')
  const homeUrl = '/'
  const helpCenterUrl = helpCenterUrls?.url || helpCenterUrls?.path || '/customer-care/help-center/'

  return (
    <Breadcrumbs>
      <Breadcrumb>
        <a href={homeUrl}>{t(`${tenant}:breadcrumbs.home`, { lng }) || 'Home'}</a>
      </Breadcrumb>

      <Breadcrumb>
        <a href={helpCenterUrl}>{t(`${tenant}:breadcrumbs.help_center`, { lng }) || 'Help Center'}</a>
      </Breadcrumb>

      {article.articleCategoryUrl && article.articleCategoryId && (
        <Breadcrumb>
          <a href={article.articleCategoryUrl}>{article.articleCategoryName || t(`${tenant}:breadcrumbs.topic`, { lng }) || 'Topic'}</a>
        </Breadcrumb>
      )}

      {article.articleSectionUrl && article.articleSectionId && (
        <Breadcrumb>
          <a href={article.articleSectionUrl}>{article.articleSectionName || t(`${tenant}:breadcrumbs.section`, { lng }) || 'Section'}</a>
        </Breadcrumb>
      )}

      <Breadcrumb>{article.articleTitle || 'Article'}</Breadcrumb>
    </Breadcrumbs>
  )
}
